// extracted by mini-css-extract-plugin
export default {"google_actions":"GoogleButton_google_actions__4F9YB","google_button":"GoogleButton_google_button__7MqfX"};